import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SingleEditService {
  public singleEditSubject = new Subject<string>();
}
